import { render, staticRenderFns } from "./CandidateEmployeeCard.vue?vue&type=template&id=05c3bd5e&scoped=true"
import script from "./CandidateEmployeeCard.vue?vue&type=script&lang=ts"
export * from "./CandidateEmployeeCard.vue?vue&type=script&lang=ts"
import style0 from "./CandidateEmployeeCard.vue?vue&type=style&index=0&id=05c3bd5e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c3bd5e",
  null
  
)

export default component.exports